import { PathBase } from '../internal/base.js';

/**
* Port from go std:
* - internal/filepathlite/path_unix.go
* - path/filepath/path_unix.go
*/
class PathUnix extends PathBase {
	static {
		this.separator = "/";
	}
	static isPathSeparator(c) {
		return c === "/";
	}
	static isLocal(path) {
		if (path === "" || this.isAbs(path)) {
			return false;
		}
		let hasDots = false;
		const parts = path.split("/");
		for (const part of parts) {
			if (part === "." || part === "..") {
				hasDots = true;
				break;
			}
		}
		if (hasDots) {
			path = this.clean(path);
		}
		return path !== ".." && !path.startsWith("../");
	}
	static localize(path) {
		if (path.includes("\0")) {
			return undefined;
		}
		return path;
	}
	static isAbs(path) {
		return path.startsWith("/");
	}
	static join(...paths) {
		const firstNonEmptyIndex = paths.findIndex((e) => e !== "");
		if (firstNonEmptyIndex === -1) {
			return "";
		}
		return this.clean(paths.slice(firstNonEmptyIndex).join("/"));
	}
	static stringEqual(a, b) {
		return a === b;
	}
}
const separator = PathUnix.separator;
const ext = PathUnix.ext.bind(PathUnix);
const base = PathUnix.base.bind(PathUnix);
const dir = PathUnix.dir.bind(PathUnix);
const clean = PathUnix.clean.bind(PathUnix);
const join = PathUnix.join.bind(PathUnix);
const rel = PathUnix.rel.bind(PathUnix);
const isAbs = PathUnix.isAbs.bind(PathUnix);

export { PathUnix, base, base as basename, clean, dir, dir as dirname, ext, ext as extname, isAbs, isAbs as isAbsolute, join, clean as normalize, rel, rel as relative, separator as sep, separator };
//# sourceMappingURL=unix.js.map
